/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential.
 *
 * WHICH ENVIRONMENT THIS BUILD IS (v1_893).
 *
 * Staging must never hold real client documents or personal data (decided
 * 01/10/26). Every page of a staging build carries a banner saying so. A build
 * is staging when REACT_APP_ENVIRONMENT says 'staging', or when it talks to the
 * staging database (its Supabase project reference). Production uses another
 * project, so it can never show the banner by accident, and staging shows it
 * without any setting being changed. The walk checks the banner is on screen,
 * so a staging build that lost it is a fault, not a silent pass.
 */
export const STAGING_SUPABASE_REFS = ['hbzuhgawzqxlsbnqgmsq'];

export function environmentName(env = (typeof process !== 'undefined' && process.env) || {}) {
  const named = String(env.REACT_APP_ENVIRONMENT || '').trim().toLowerCase();
  if (named) return named;
  let ref = '';
  try { ref = new URL(String(env.REACT_APP_SUPABASE_URL || '')).host.split('.')[0].toLowerCase(); } catch (_) {}
  return STAGING_SUPABASE_REFS.includes(ref) ? 'staging' : 'production';
}

export const isStagingBuild = (env) => environmentName(env) === 'staging';

export const STAGING_BANNER_TEXT = 'TEST ENVIRONMENT · no real client documents or data';
